import React, { useEffect, useState } from "react"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { debounce } from "../../helpers/debounce"
import CampaignPaymentBills from "../../pages/campaigns/payments/bills"
import { useLanguage } from "@languages/index"
import dayjs from "dayjs"
import classNames from "classnames"
import { BrandDtoEnums } from "api/repositories/brand/brand.types"

interface Props {
  history?: any

  // REDUX
  showModal?: (params?: any) => void
  showSheet?: (params?: any) => void
  closeOverlays?: () => void
  showOverlays?: (params?: any) => void
}

const CampaignPaymentHistoryItem = (props: Props) => {
  const language = useLanguage()
  const languageTexts = {
    ...language.common,
    ...language.component.campaignPaymentHistoryItem
  }

  const showBills = () => {
    props.closeOverlays()
    debounce(() => {
      props.showOverlays({
        content: () => {
          return <CampaignPaymentBills {...props} history={props.history} />
        },
      })
    }, 400)
  }

  const renderMetaData = (metaDataJsonText:any) => {
    try {
      const metaData = JSON.parse(metaDataJsonText)

      const texts = []
      // @note 메타데이터에.. 상향지원 정보도 있어서 필요할 경우 표기 가능. 일단은 추가선정만 표기
      if (metaData?.tags?.is_additional_seeding)
        texts.push(languageTexts.index_text_5);

      return texts.length > 0 ? (
        <div className="text-[12px] text-[#999]">
          {`${texts.join(' + ')}`}
        </div>
      ) : null

    } catch (e) {
      return null
    }
  }

  const renderBillingType = (params: {
    billingType: BrandDtoEnums['billingType'];
  }) => {
    switch (params.billingType) {
      case 'FREE':
        return languageTexts.index_text_1
      case 'PAID':
        return languageTexts.index_text_2
      default:
        return 'UNSET'
    }
  }

  const renderTaxInvoiceInfo = (params: {
    billingType: BrandDtoEnums['billingType'];
    taxInvoiceScheduledDate?: string | null;
    taxInvoiceIssuedAt?: string | null;
  }) => {
    switch (params.billingType) {
      case 'FREE':
        if (params.taxInvoiceIssuedAt) {
          return (
            <>
              <div>{languageTexts.index_text_6}</div>
              <div className="text-[#999]">
                {dayjs(params.taxInvoiceIssuedAt).format('YY.MM.DD')}
              </div>
            </>
          )
        } else {
          return (
            <>
              <div>{languageTexts.index_text_3}</div>
              {params.taxInvoiceScheduledDate && (
                <div className="text-[#999]">
                  {dayjs(params.taxInvoiceScheduledDate).format('YY.MM.DD')}
                </div>
              )}
            </>
          )
        }
      case 'PAID':
        return (
          <>
            <div>{languageTexts.index_text_4}</div>
          </>
        )
      default:
        return 'UNSET'
    }
  }

  return (
    <div
      id={`campaign-payment-${props.history.id}`}
      className={classNames([
        "px-5 py-4",
        "grid grid-cols-[1fr_auto_auto_auto_auto] gap-3 items-center",
        "border-b border-grey-200 text-[12px]",
      ])}
    >
      {/* 결제내역 */}
      <div className="text-start">
        <div>{props.history.typeDesc}</div>
        {props.history?.metaData != null
          ? renderMetaData(props.history.metaData)
          : null}
      </div>

      {/* 결제방법 */}
      <div className="text-center">
        {renderBillingType({
          billingType: props.history.billingType,
        })}
      </div>

      {/* 세금계산서 발급정보 */}
      <div className="min-w-[120px] flex flex-col items-center">
        {renderTaxInvoiceInfo({
          billingType: props.history.billingType,
          taxInvoiceScheduledDate: props.history.taxInvoiceScheduledDate,
          taxInvoiceIssuedAt: props.history.taxInvoiceIssuedAt,
        })}
      </div>

      {/* 결제일 */}
      <div className="flex flex-col items-center">
        <div>{languageTexts.payment}</div>
        <div className="text-[#999]">
          {dayjs(props.history.createdDate).format('YY.MM.DD')}
        </div>
      </div>

      {/* 영수증 */}
      <div
        className="text-end text-[#999] underline select-none cursor-pointer"
        onClick={(e) => {
          e.preventDefault()
          showBills()
        }}
      >
        {languageTexts.bills}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(CampaignPaymentHistoryItem)
